import { Player } from './Player.type'
import { PlayerKind } from './PlayerKind.enum'

export default function isPlayerSlotTaken(player: Player): boolean {
  if (player.is_local) {
    return (player.kind === PlayerKind.Bot || player.kind === PlayerKind.Human)
  }
  return (player.bot_id || player.invite_id || player.profile_id) as unknown as boolean
}
